import axios from 'axios';
import React ,{useEffect} from 'react';

function Privacypolicy() {
   useEffect(() => {
        const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
        axios.post(`${backendUrl}/api/analytics/visit`, { page: "Privacy Policy" })
          .then(res => console.log(" visit recorded:", res.data))
          .catch(err => console.error("Analytics error:", err));
      }, []);
  return (
    <div className="px-16 lg:px-32 py-6">
      {/* Centered Title */}
      <h1 className="text-2xl font-bold text-center mb-8 text-[#FF4902]">Privacy Policy</h1>
      
      {/* Content */}
      <p className="mb-4">
        At <strong>Mammoth Streetwears</strong>, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal data when you visit our website{' '}
        <a href="http://www.mammothstreetwears.com" className="text-blue-600 underline">
          www.mammothstreetwears.com
        </a>
        , purchase products from us, or engage with us in other ways.
      </p>
      <p className="mb-4">
        By accessing or using our website, you agree to the collection and use of information in accordance with this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p className="mb-4">
        We collect various types of personal information when you visit our website, place an order, or interact with us in other ways. This may include:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          <strong>Personal Information You Provide to Us:</strong>
          <ul className="list-disc ml-6">
            <li>
              <strong>Account Information:</strong> When you create an account, we may collect your name, email address, phone number, billing and shipping address, and password.
            </li>
            <li>
              <strong>Order Information:</strong> When you place an order, we collect your payment details (credit/debit card information, UPI, etc.), shipping address, and order history.
            </li>
            <li>
              <strong>Customer Support Interactions:</strong> If you contact our customer service team, we may collect details about your inquiry or issue, as well as any correspondence with us.
            </li>
            <li>
              <strong>Newsletter & Marketing Preferences:</strong> If you subscribe to our newsletter or marketing communications, we collect your email address and preferences.
            </li>
          </ul>
        </li>
        <li className="mt-4">
          <strong>Automatically Collected Information:</strong>
          <ul className="list-disc ml-6">
            <li>
              <strong>Cookies and Tracking Technologies:</strong> We use cookies and similar technologies to enhance your browsing experience and collect information about your usage patterns on our website. This includes your IP address, browser type, device information, and pages you visit.
            </li>
            <li>
              <strong>Analytics:</strong> We use third-party analytics tools, such as Google Analytics, to gather data about your interactions with our website to improve the user experience and analyze trends.
            </li>
          </ul>
        </li>
        <li className="mt-4">
          <strong>Payment Information:</strong> We do not store full credit card or debit card details. Payments are processed securely through a third-party payment provider (such as PayPal, Stripe, etc.), and we only receive the necessary details to complete your order (such as transaction ID and confirmation).
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <p className="mb-4">We use the personal information we collect for various purposes, including:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Order Processing and Fulfillment</li>
        <li>Communication</li>
        <li>Marketing</li>
        <li>Website Improvement</li>
        <li>Security</li>
        <li>Legal Compliance</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. How We Share Your Information</h2>
      <p className="mb-4">
        We do not sell your personal information to third parties. However, we may share your data with trusted third parties in the following situations:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          <strong>Service Providers:</strong> We may share your information with trusted service providers who help us manage our website, process payments, fulfill orders, and provide customer support. These service providers are contractually obligated to protect your data and use it only for the purpose of providing services to us.
        </li>
        <li>
          <strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of assets, your personal information may be transferred as part of that transaction.
        </li>
        <li>
          <strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to a valid legal request, such as a court order or government inquiry.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. How We Protect Your Information</h2>
      <p className="mb-4">
        We implement a variety of security measures to maintain the safety of your personal information, including:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          <strong>Encryption:</strong> We use secure socket layer (SSL) encryption to protect sensitive data during transmission, such as credit card information.
        </li>
        <li>
          <strong>Access Controls:</strong> We limit access to your personal data to employees, contractors, or service providers who need to know this information in order to provide services.
        </li>
        <li>
          <strong>Regular Security Audits:</strong> We regularly assess our security practices to ensure they remain up to date and effective.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Privacy Rights</h2>
      <p className="mb-4">
        Depending on your location, you may have certain rights regarding your personal information. These may include:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Access and Correction</li>
        <li>Data Deletion</li>
        <li>Opt-Out of Marketing</li>
        <li>Data Portability</li>
        <li>Withdraw Consent</li>
      </ul>
      <p className="mb-4">
        To exercise any of these rights, please contact us at{' '}
        <a href="mailto:info@mammothstreetwears.com" className="text-blue-600 underline">
          info@mammothstreetwears.com
        </a> or{' '}
        <a href="tel:+7276765568" className="text-blue-600 underline">
          7276765568
        </a>.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Cookies and Tracking Technologies</h2>
      <p className="mb-4">
        We use cookies and similar technologies to collect and store certain information about your usage of our website. Cookies are small text files that are placed on your device when you visit our site. You can control how cookies are used through your browser settings. However, disabling certain cookies may affect the functionality of our website.
      </p>
      <p className="mb-4">
        For more details, please refer to our <a href="#" className="text-blue-600 underline">Cookie Policy</a>.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Third-Party Links</h2>
      <p className="mb-4">
        Our website may contain links to third-party websites that are not operated or controlled by us. We are not responsible for the privacy practices of those websites. We encourage you to review the privacy policies of any third-party websites before providing any personal information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. International Transfers</h2>
      <p className="mb-4">
        If you are located outside of India, please note that your information may be transferred to and processed in India, where our servers are located. By using our website and providing your information, you consent to such transfers.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Children’s Privacy</h2>
      <p className="mb-4">
        Our website is not intended for individuals under the age of 13, and we do not knowingly collect personal information from children. If you believe that we have collected information from a child under 13, please contact us immediately, and we will take steps to delete such information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the updated version will be effective as of the "Effective Date" above. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Contact Us</h2>
      <p className="mb-4">
        If you have any questions or concerns about this Privacy Policy, or if you wish to exercise your privacy rights, please contact us at:
      </p>
      <address className="mb-4">
        <strong>Mammoth Streetwear</strong> <br />
        Email:{' '}
        <a href="mailto:info@mammothstreetwears.com" className="text-blue-600 underline">
        info@mammothstreetwears.com
        </a>{' '}
        <br />
        Phone:{' '}
        <a href="tel:+7276765568" className="text-blue-600 underline">
          7276765568
        </a> <br />
        Address: Office No-102, Kalpana Tarang Apt, Opp, Ranka<br />Jewellers, Karve Road, Erandwane, Pune-411004
      </address>
    </div>
  );
}

export default Privacypolicy;
